import React from "react";
import { useRetrieveDescription } from "../../../hooks/description";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PathwayDescription = ({ pathwayInternalId, label }) => {
  const { data, isLoading } = useRetrieveDescription(pathwayInternalId);

  return (
    <span>
      <b>
        {label}
        {": "}
      </b>
      {isLoading ? (
        <FontAwesomeIcon icon="spinner" spin style={{ placeSelf: "center" }} />
      ) : (
        <span
          style={{
            lineHeight: 1.4,
            textAlign: "justify",
            textJustify: "inter-word",
          }}
        >
          {data.description}
        </span>
      )}
    </span>
  );
};

export default PathwayDescription;
